module.exports = __webpack_public_path__ + "static/wcagDocs-d4329b1ddb0cf9e311ea8fe8934712d1.gif";